import { defineComponent, createElementBlock, createCommentVNode, openBlock, createElementVNode, toDisplayString } from "vue";
const _hoisted_1 = ["alt", "src"];
const _hoisted_2 = {
  key: 1,
  class: "header-name"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "HeaderItemMeta",
  props: {
    logo: {},
    projectName: {},
    primaryVersionUid: {}
  },
  emits: ["navigate"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    return (_ctx, _cache) => {
      return _ctx.logo ? (openBlock(), createElementBlock("button", {
        key: 0,
        class: "header-item-logo",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event) => emit("navigate", _ctx.primaryVersionUid, "version"))
      }, [
        createElementVNode("img", {
          alt: _ctx.projectName,
          class: "header-item-logo-image",
          src: _ctx.logo
        }, null, 8, _hoisted_1)
      ])) : _ctx.projectName ? (openBlock(), createElementBlock("span", _hoisted_2, toDisplayString(_ctx.projectName), 1)) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=HeaderItemMeta.vue.js.map
